import { c as _c } from "react/compiler-runtime";
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { addSearchParams } from '@/utils/fetcher';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { Category } from './functions/getCategories';
import { CategoriesList } from './CategoriesList';
import { useEffect } from 'react';
import { logEvent } from '@/analytics/events';
const getPhrases = (lang?: string) => {
  switch (lang) {
    case 'cs':
      {
        return ['Notino', 'Trenýrkárna', 'Vivantis', 'Parfémy', 'Lékárna', 'Nábytek'];
      }
    default:
      throw new Error(`Language ${lang} is not supported`);
  }
};
interface Props {
  emptyCategories: Category[];
}
export function NoResults(props) {
  const $ = _c(42);
  const {
    t
  } = useTranslation("discounts");
  const router = useRouter();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("noResults.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <h2 className="mt-12 mb-2 text-xl font-semibold lg:mt-16">{t1}</h2>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("noResults.list.0");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <li>{t3}</li>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("noResults.list.1");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <li>{t5}</li>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("noResults.list.2");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <li>{t7}</li>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t9 = <ul className="mb-8 max-w-4xl list-disc space-y-2 pl-5 marker:text-blue-500">{t4}{t6}{t8}</ul>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t("noResults.recommendationPhrase");
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10) {
    t11 = <h2 className="mt-12 text-xl font-semibold lg:mt-16">{t10}</h2>;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== router.locale) {
    t12 = getPhrases(router.locale || "cs").map(_temp2);
    $[25] = router.locale;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12) {
    t13 = <div className="mt-3 flex flex-wrap gap-4 lg:gap-6">{t12}</div>;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("noResults.recommendationCategory");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t14) {
    t15 = <h2 className="mt-12 mb-5 text-xl font-semibold lg:mt-16">{t14}</h2>;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== props.emptyCategories) {
    t16 = <CategoriesList categories={props.emptyCategories} />;
    $[33] = props.emptyCategories;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== t11 || $[36] !== t13 || $[37] !== t15 || $[38] !== t16 || $[39] !== t2 || $[40] !== t9) {
    t17 = <div>{t2}{t9}{t11}{t13}{t15}{t16}</div>;
    $[35] = t11;
    $[36] = t13;
    $[37] = t15;
    $[38] = t16;
    $[39] = t2;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
}
function _temp2(text, index) {
  return <p key={text}><Link analyticsParam={`recommendationPhrase${index}`} testId={`recommendationPhrase${index}`} to={addSearchParams(LINKS().discounts, {
      q: text
    })}>{text}</Link></p>;
}
function _temp() {
  logEvent("no_results", {
    action: "search",
    search_term: window?.location.search
  });
}